module.exports = __webpack_public_path__ + "static/img/img-home-jzg-06.e3a6398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-jzg-06.png
// module id = 2qCp
// module chunks = 1